import { connect } from 'react-redux';
import { IState } from '../../store';
import { isABAgentExperienceExperiment } from '../../utils/ab_agent_experience';
import { AuthorAside, IAuthorAsideProps } from './index';
import { showCountrysideBuilderBadge } from '../../utils/suburban';
import { isPro, isHonest } from '../../utils/agent';
import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export function mapStateToProps(state: IState): IAuthorAsideProps {
  const agent = state.offerData.agent || ({} as IAgentSchema);

  const isProAgent = isPro(agent);
  const isHonestAgent = isHonest(agent);

  return {
    agent: state.offerData.agent,
    agentReviews: state.offerData.agentReviews,
    developer: state.offerData.newObject && state.offerData.newObject.developer,
    isAgentExperienceExperimentActive: isABAgentExperienceExperiment(state.experiments),
    offer: state.offerData.offer,
    showCountrysideBuilderBadge: showCountrysideBuilderBadge(state),
    isProAgent,
    isHonestAgent,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AuthorAsideContainer = connect(mapStateToProps)(AuthorAside);
